import Vue from "vue";
import App from "./App.vue";
import router from "./router/router";

import vuetify from "./plugins/vuetify";

import "@/styles/main.scss";

import "flag-icon-css/css/flag-icon.css";

import CheckUserRolesMixin from "@/mixins/CheckUserRolesMixin";
import SnackMixin from "@/mixins/SnackMixin";

Vue.config.productionTip = false;

Vue.mixin(CheckUserRolesMixin);
Vue.mixin(SnackMixin);

Vue.filter("shortString", (value: string, maximumLength?: number): string => {
  const maxLength = maximumLength || 50;
  if (value) {
    return value.length > maxLength ? value.slice(0, maxLength) + "..." : value;
  }
  return value;
});

import setup from "./setupAuth";
setup().then(() => {
  new Vue({
    vuetify,
    router,
    render: (h) => h(App),
    data: () => {
      return { user: null as any, title: null as any };
    },
  }).$mount("#app");
});
